(() => {
  const membershipVariantId = '56238770159988';
  let normalizationPromise;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function changeMembershipQuantity(item, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: item.key, quantity }),
    });
    if (!response.ok) throw new Error('Unable to update membership quantity');
    return response.json();
  }

  async function normalizeMembershipQuantity() {
    if (normalizationPromise) return normalizationPromise;

    normalizationPromise = (async () => {
      const cart = await getCart();
      const membershipItem = cart.items.find(
        (item) => String(item.variant_id) === membershipVariantId
      );

      if (membershipItem && membershipItem.quantity !== 1) {
        await changeMembershipQuantity(membershipItem, 1);
        return { changed: true, item: membershipItem };
      }

      return { changed: false, item: membershipItem };
    })().finally(() => {
      normalizationPromise = undefined;
    });

    return normalizationPromise;
  }

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const result = await normalizeMembershipQuantity();
      if (result.changed && window.location.pathname === '/cart') {
        window.location.reload();
      }
    } catch (error) {
      console.error('[Pattern Haven] Membership quantity normalization failed.', error);
    }
  });

})();
